import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';

const ItemsSkeleton = ({length = 9,xs = 12,md = 6,sm = 6,lg = 6,height = 200,style}) => {
    const gridItems = Array.from({ length: length });

    return (
        <>
            {gridItems.map((_, index) => (
                <Grid item size={{xs:xs,sm:sm,md:md,lg:lg}} key={index} style={style}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={height}
                        style={{borderRadius:12}}
                    />
                </Grid>
            ))}
        </>
    );
};

export default ItemsSkeleton;
